'use client';

import { formatDayLabel } from './dmDate';

export default function DaySeparator({ iso }: { iso: string }) {
  return (
    <div
      className="my-3 flex items-center gap-3"
      role="separator"
      aria-label={formatDayLabel(iso)}
    >
      <span className="flex-1 h-px bg-border-subtle" />
      <span className="text-[11px] uppercase tracking-wider text-text-tertiary font-mono">
        {formatDayLabel(iso)}
      </span>
      <span className="flex-1 h-px bg-border-subtle" />
    </div>
  );
}
